<template>
  <div class="Scale_classification">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="background-color: #fff;padding: 14px;">
      <el-form-item label="量表代号">
        <el-input v-model="formInline.user" placeholder="量表代号"></el-input>
      </el-form-item>
      <el-form-item label="量表名称">
        <el-input v-model="formInline.user" placeholder="量表名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="Scale_classification_nav">
      <div class="Scale_classification_nav_left">
        <el-tree style="margin-top: 20px;" :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="Scale_classification_nav_right">
        <el-button type="primary" style="margin-left: 1%;margin-top: 14px;" @click="addfun()">新增</el-button>
        <el-table :data="tableData" style="width: 98%;margin-left: 1%;margin-top: 14px;">
          <el-table-column prop="date" label="日期" width="180"></el-table-column>
          <el-table-column prop="name" label="姓名" width="180"></el-table-column>
          <el-table-column prop="address" label="地址"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        },
        data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1二级 1-1二级 1-1二级 1-1二级 1-1二级 1-1二级 1-1二级 1-1二级 1-1',
            children: [{
              label: '大众心理健康状况及影响因素调查-本专科生群体'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄11111'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄2222222'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄333'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄4444444'
        }]
      };
    },
    components:{

    },
    methods: {
      addfun() {
        this.$router.push({
          path: '/Scale/Add_instruction',
        })
      },
      onSubmit() {
        console.log('submit!');
      },
      handleNodeClick(data) {
        console.log(data);
      }
    }
  };
</script>
<style>
.Scale_classification{width: 100%;height: 100%;}
.Scale_classification_nav{width: 100%;height: calc(100% - 104px);margin-top: 14px;}
.Scale_classification_nav_left{width: 450px;height: 100%;overflow: auto;float: left;background-color: #fff;}
.Scale_classification_nav_right{width: calc(100% - 464px);height: 100%;float: right;background-color: #fff;}
</style>